import Mustangs from "./photos/IMG_6772.jpg";
import Morgan from "./photos/IMG_6773.jpg";
import All from "./photos/img1.jpeg";
import cv from "./photos/IMG_7804.jpeg";
import og from "./photos/IMG_0035.jpeg";
import mr from "./photos/IMG_0830.jpeg";
import cd from "./photos/IMG_7807.jpeg";
import gc from "./photos/IMG_7805.jpeg";
import br from "./photos/IMG_7813.jpeg";
import rd from "./photos/IMG_7809.jpeg";
import rh from "./photos/IMG_7812.jpeg";
import al from "./photos/PHOTO-2023-04-19-12-48-26.jpeg";
import mg from "./photos/IMG_8239.JPG";
import fr from "./photos/IMG_8241.JPG";

export let midia = [
    {
        caption:"University of Utah Showcase - LCA x Mustangs",
        link: "https://app.veo.co/matches/utah-avalanche-20230122-nuno-gourgel-164630-322150f5/",
        image: Mustangs,
        jv: "https://app.veo.co/matches/utah-avalanche-20230123-nuno-gourgel-game-3-sunday-2dcc764d/"
    },

    {
        caption:"University of Utah Showcase - LCA x Cedar Valley",
        link: "https://app.veo.co/matches/utah-avalanche-20230123-nuno-gourgel-game-4-sunday-8d88e4e5/",
        image: cv,
        jv: "https://app.veo.co/matches/utah-avalanche-20230122-nuno-gourgel-lca-2-vs-cedar-valley-1bfb2dfa/"
    },

    {
        caption:"University of Utah Showcase - LCA x Morgan",
        link: "https://app.veo.co/matches/utah-avalanche-20230122-nuno-gourgel-game-1-sunday-b0f24f02/",
        image: Morgan,
        jv: ""
    },

    {
        caption:"University of Utah Showcase - Photos",
        link: "https://drive.google.com/drive/folders/1kiB4xXU43OYUslZY9uKDd0ZMfCcHIW1V",
        image: All,
        jv: ""
    },

    {
        caption:"LCA x Cedar",
        link: "https://app.veo.co/matches/layton-christian-academy-20230308-zm_cedar-city-chs_varsity-at-layton-christian-df1b799d/",
        image: cd,
        jv: ""
    },

    {
        caption:"LCA x Green Canyon",
        link: "https://www.youtube.com/watch?v=0nKwqM0BxI0",
        image: gc,
        jv: ""
    },

    {
        caption:"LCA x Bear River",
        link: "https://youtube.com/live/T1REThuF_3I?feature=share",
        image: br,
        jv: ""
    },

    {
        caption:"LCA x Ogden",
        link: "https://app.veo.co/matches/20230112-48c5849a-fb7a-44ed-bf50-c0eab6210845-212fa2e4/",
        image: og,
        jv: ""
    },

    {
        caption:"LCA x Mountain Ridge",
        link: " https://app.veo.co/matches/20230321-lca-vs-mountain-ridge-274c5785/",
        image: mr,
        jv: "https://app.veo.co/matches/20230322-jv-lca-vs-mountain-ridge-ebfc208e/"
    },

    {
        caption:"LCA x Ridgeline",
        link: "https://app.veo.co/matches/20230401-lca-vs-ridgeline-8ea74a88/",
        image: rd,
        jv: "https://app.veo.co/matches/20230323-jv-lca-vs-ridgeline-1e2c1801/"
    },

    {
        caption:"LCA x Rowland Hall",
        link: "https://app.veo.co/matches/20230414-lca-vs-rowland-hall-ab14d4be/",
        image: rh,
        jv: "https://app.veo.co/matches/20230415-jv-lca-vs-rowland-hall-a90c85cd/"
    },

    {
        caption:"LCA x Alta",
        link: "https://app.veo.co/matches/20230418-lca-vs-alta-96bf8191/",
        image: al,
        jv: "https://app.veo.co/matches/20230419-jv-lca-vs-alta-927ed229/"
    },

    {
        caption:"LCA x Morgan",
        link: "https://app.veo.co/matches/20230420-lca-vs-morgan-33358971/",
        image: mg,
        jv: "https://app.veo.co/matches/20230421-jv-lca-x-morgan-93e6c27d/"
    },

    {
        caption:"LCA x LCA USSA (Friendly)",
        link: "https://app.veo.co/matches/20230503-lca-training-vs-ussa-5344cf92/",
        image: fr,
        jv: ""
    },


]